module.exports = __webpack_public_path__ + "img/white03_128.bc53c8c3.png";